import {useState} from "react";
import useInvoices from "../../../state/ordering/useInvoices";
import HeaderSkeleton from "../ordering/HeaderSkeleton";
import HeaderInvoice from "../ordering/HeaderInvoice";
import {idempiereDate} from "../../../../res/dataServices/idempiereDate";
import RangeSelector from "../../../account/component/RangeSelector";

const DEFAULT_MONTHS = 12;
const DEFAULT_DATE = idempiereDate.getXMonthsAgo(DEFAULT_MONTHS);
const DEFAULT_START = "'" + idempiereDate.getDateString(DEFAULT_DATE) + "'";
const DEFAULT_END = "'" + idempiereDate.getDateString(new Date()) + "'"
const DEFAULT_LIMIT = 10;

const AccountLayoutInvoices = () => {

    const [ reloaded, setReloaded ] = useState(false);

    const {
        ordering,
        passedDueList,
        unpaidList,
        paidList,
        links,
        loading,
        fetchedDates,
        getInvoicesByDate
    } = useInvoices();

    if(!reloaded) {
        setReloaded(true);
        getInvoicesByDate(DEFAULT_START, DEFAULT_END, DEFAULT_LIMIT);
    }

    const showLoading = loading.invoices;

    const displayList = (list) => {
        return !loading.invoices
            && list && list.length > 0;
    }

    const getInvoiceOrders = (invoice) => {
        const orderIDs = links[invoice.id].orders;
        const orders = [];
        orderIDs.forEach(id => orders.push(ordering.orders[id]));
        return orders;
    }
    const getInvoiceShipments = (invoice) => {
        const shipmentIDs = links[invoice.id].shipments;
        const shipments = [];
        shipmentIDs.forEach(id => shipments.push(ordering.shipments[id]));
        return shipments;
    }



    const onRangeRequest = (startDate, endDate) => {
        if(!showLoading) {

            const idStartDate = `'${idempiereDate.getDateString(startDate)}'`;
            const idEndDate   = `'${idempiereDate.getDateString(endDate)}'`;

            if(!fetchedDates || !(fetchedDates.startDate === idStartDate && fetchedDates.endDate)) {
                getInvoicesByDate(idStartDate, idEndDate);
            }
        }
    }

    return (
        <>
            <h1>Invoices</h1>
            <RangeSelector
                maxDates={DEFAULT_MONTHS}
                buttonText="Load Invoices"
                loading={showLoading}
                onRequest={onRangeRequest}
            />
            {(!ordering.invoices || Object.keys(ordering.invoices).length === 0) && !showLoading &&
                <div className="account-view-list">
                    <h1>Invoices</h1>
                    <p>Sorry! No invoices could be found for the given date range!</p>
                </div>
            }
            {showLoading &&
                <div className="account-view-list">
                    {[...Array(4).keys()].map((e,i) =>
                        <HeaderSkeleton v key={i} />
                    )}
                </div>
            }
            {displayList(passedDueList) &&
                <div className="account-view-list">
                    <p className="account-heading-large">Passed Due</p>
                    {passedDueList.map((e,i) =>
                        <HeaderInvoice
                            key={i}
                            invoice={e}
                            shipments={getInvoiceShipments(e)}
                            orders={getInvoiceOrders(e)}
                        />
                    )}
                </div>
            }
            {displayList(unpaidList) &&
                <div className="account-view-list">
                    <p className="account-heading-large">Due</p>
                    {unpaidList.map((e,i) =>
                        <HeaderInvoice
                            key={i}
                            invoice={e}
                            shipments={getInvoiceShipments(e)}
                            orders={getInvoiceOrders(e)}
                        />
                    )}
                </div>
            }
            {displayList(paidList) &&
                <div className="account-view-list">
                    <h2 className="account-heading-large">Settled</h2>
                    {paidList.map((e,i) =>
                        <HeaderInvoice
                            key={i}
                            invoice={e}
                            shipments={getInvoiceShipments(e)}
                            orders={getInvoiceOrders(e)}
                        />
                    )}
                </div>
            }
        </>
    )

}

export default AccountLayoutInvoices;
